import { gql } from "@apollo/client";
import { REPORT_FRAGMENT } from "./getArchivedReportsCall";
import { MutateReportResponse } from "./createReportCall";

export const UPDATE_REPORT = gql`
  mutation Update($domain: String!, $input: [ReportInput!]!, $ifFetchData: Boolean!) {
    report {
      update(domain: $domain, input: $input) {
        code
        message
        success
        updatedValues {
          ...ReportFields          
        }
      }
    }
  }
  ${REPORT_FRAGMENT}
`

export interface UpdateReportResponse {
  report: {
    update: MutateReportResponse
  }
}